import {PortfolioType} from '../portfolio-type.model';
import {PreferredCategories} from '../portfolio-preferences.model';
import {PortfolioCreationData} from './portfolio-creation-data.model';

export class AutoInvestPortfolioCreationData implements PortfolioCreationData {
    portfolioName: string;
    portfolioAmount: number;
    tempPortfolioId: string;
    portfolioPreference: PreferredCategories[];
    readonly portfolioType: PortfolioType = PortfolioType.AutoInvest;

    constructor(tempPortfolioId: string, portfolioAmount: number, portfolioPreference: PreferredCategories[] = [], portfolioName?: string) {
        this.portfolioName = portfolioName;
        this.portfolioAmount = portfolioAmount;
        this.tempPortfolioId = tempPortfolioId;
        this.portfolioPreference = portfolioPreference;
    }

    static from(portfolioCreationData: any) {
        return new AutoInvestPortfolioCreationData(portfolioCreationData.tempPortfolioId, portfolioCreationData.portfolioAmount,
            portfolioCreationData.portfolioPreference, portfolioCreationData.portfolioName);
    }
}